
import React from "react";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import FormField from "./FormField";
import PasswordField from "./PasswordField";
import SubmitButton from "./SubmitButton";

type LoginFormProps = {
  formData: {
    email: string;
    password: string;
  };
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isLoading: boolean;
  formErrors?: {
    [key: string]: string;
  };
};

const LoginForm = ({ formData, handleChange, isLoading, formErrors }: LoginFormProps) => {
  return (
    <>
      <FormField
        id="email"
        label="Email"
        type="email"
        placeholder="example@email.com"
        value={formData.email}
        onChange={handleChange}
        required
        icon={<Mail />}
        error={formErrors?.email}
      />

      <PasswordField
        id="password"
        label="Password"
        placeholder="••••••••"
        value={formData.password}
        onChange={handleChange}
        required
        error={formErrors?.password}
      />

      <div className="flex items-center justify-end">
        <Link
          to="/password-reset"
          className="text-sm text-primary hover:underline"
        >
          Forgot password?
        </Link>
      </div>

      <SubmitButton isLoading={isLoading} text="Sign In" />
    </>
  );
};

export default LoginForm;
